import React from 'react';
import classNames from 'classnames';
import generateClassModifiers from '../../helpers/generate-class-modifiers';
const defaultBreakpoints = {};

const Box = ({ children, breakpoints = defaultBreakpoints, ...spaces }) => {
  const spacesClasses = generateClassModifiers('ws-ui-box', spaces);
  const breakpointsSpacesClasses =
    breakpoints &&
    Object.keys(breakpoints).map((key) =>
      generateClassModifiers('ws-ui-box', breakpoints[key], key)
    );

  const classes = classNames('ws-ui-box', spacesClasses, breakpointsSpacesClasses);

  return <div className={classes}>{children}</div>;
};

export default Box;
